/**
 * WordPress dependencies
 */
import { cloneElement, forwardRef } from '@wordpress/element';

/**
 * External dependencies
 */

/**
 * Return an SVG icon.
 *
 * @param props The component props.
 *
 * @return Icon component
 */
export default forwardRef(({
  icon,
  size = 24,
  ...props
}, ref) => {
  return cloneElement(icon, {
    width: size,
    height: size,
    ...props,
    ref
  });
});
//# sourceMappingURL=index.js.map